import { getCalendarioMensual } from "../../API/CalendarioOperativo/CalendarioOperativoRequest"
import { getMonthNames } from "../../Base/Services/FechasService"



export const InformacionCalendarioMensual = async() =>{
    const resultado = await getCalendarioMensual()
    let calendarioMeses = []
    let language = 'es'
    calendarioMeses = resultado.map((e) => {
        return {
            IdMes: e.IdMes,
            Mes: getMonthNames((e.NoMes - 1), language),
            Semanas: e.NoSemanas,
            FechaInicio: (e.InicioMes),
            FechaFinal: (e.FinMes),
            Anio: e.Anio,
            MesRango: getMonthNames((e.NoMes - 1), language) + "-" + e.Anio,
            MesNumero: e.NoMes
        }
    })

    return calendarioMeses
}